export default "__VITE_ASSET__Ut2Js92x__"